// extracted by mini-css-extract-plugin
module.exports = {"container":"DraggableElement_container__15ydx","dot":"DraggableElement_dot__2bZuX"};